export interface Country {
  value: string;
  text: string;
  code: string | 0;
  eu?: boolean;
}

export const countries: Country[] = [
  { value: 'af', text: 'Afghanistan', code: '93' },
  { value: 'al', text: 'Albania', code: '355' },
  { value: 'dz', text: 'Algeria', code: '213' },
  { value: 'as', text: 'American Samoa', code: '684' },
  { value: 'ad', text: 'Andorra', code: '376' },
  { value: 'ao', text: 'Angola', code: '244' },
  { value: 'ai', text: 'Anguilla', code: '1264' },
  { value: 'aq', text: 'Antarctica', code: '672' },
  { value: 'ag', text: 'Antigua and Barbuda', code: '1268' },
  { value: 'ar', text: 'Argentina', code: '54' },
  { value: 'am', text: 'Armenia', code: '374' },
  { value: 'aw', text: 'Aruba', code: '297' },
  { value: 'au', text: 'Australia', code: '61' },
  { value: 'at', text: 'Austria', code: '43', eu: true },
  { value: 'az', text: 'Azerbaijan', code: '994' },
  { value: 'bs', text: 'Bahamas', code: '1242' },
  { value: 'bh', text: 'Bahrain', code: '973' },
  { value: 'bd', text: 'Bangladesh', code: '880' },
  { value: 'bb', text: 'Barbados', code: '1246' },
  { value: 'by', text: 'Belarus', code: '375' },
  { value: 'be', text: 'Belgium', code: '32', eu: true },
  { value: 'bz', text: 'Belize', code: '501' },
  { value: 'bj', text: 'Benin', code: '229' },
  { value: 'bm', text: 'Bermuda', code: '1441' },
  { value: 'bt', text: 'Bhutan', code: '975' },
  { value: 'bo', text: 'Bolivia, Plurinational State of', code: '591' },
  { value: 'bq', text: 'Bonaire, Sint Eustatius and Saba', code: 0 },
  { value: 'ba', text: 'Bosnia and Herzegovina', code: '387' },
  { value: 'bw', text: 'Botswana', code: '267' },
  { value: 'bv', text: 'Bouvet Island', code: 0 },
  { value: 'br', text: 'Brazil', code: '55' },
  { value: 'io', text: 'British Indian Ocean Territory', code: '246' },
  { value: 'bn', text: 'Brunei Darussalam', code: '673' },
  { value: 'bg', text: 'Bulgaria', code: '359', eu: true },
  { value: 'bf', text: 'Burkina Faso', code: '226' },
  { value: 'bi', text: 'Burundi', code: '257' },
  { value: 'kh', text: 'Cambodia', code: '855' },
  { value: 'cm', text: 'Cameroon', code: '237' },
  { value: 'ca', text: 'Canada', code: '1' },
  { value: 'cv', text: 'Cape Verde', code: '238' },
  { value: 'ky', text: 'Cayman Islands', code: '1345' },
  { value: 'cf', text: 'Central African Republic', code: '236' },
  { value: 'td', text: 'Chad', code: '235' },
  { value: 'cl', text: 'Chile', code: '56' },
  { value: 'cn', text: 'China', code: '86' },
  { value: 'cx', text: 'Christmas Island', code: '61' },
  { value: 'cc', text: 'Cocos (Keeling) Islands', code: '61' },
  { value: 'co', text: 'Colombia', code: '57' },
  { value: 'km', text: 'Comoros', code: '269' },
  { value: 'cg', text: 'Congo', code: '242' },
  { value: 'cd', text: 'Congo, Democratic Republic of the', code: '243' },
  { value: 'ck', text: 'Cook Islands', code: '682' },
  { value: 'cr', text: 'Costa Rica', code: '506' },
  { value: 'hr', text: 'Croatia', code: '385', eu: true },
  { value: 'cu', text: 'Cuba', code: '53' },
  { value: 'cw', text: 'Curaçao', code: '599' },
  { value: 'cy', text: 'Cyprus', code: '357', eu: true },
  { value: 'cz', text: 'Czech Republic', code: '420', eu: true },
  { value: 'ci', text: "Côte d'Ivoire", code: '225' },
  { value: 'dk', text: 'Denmark', code: '45', eu: true },
  { value: 'dj', text: 'Djibouti', code: '253' },
  { value: 'dm', text: 'Dominica', code: '767' },
  { value: 'do', text: 'Dominican Republic', code: '809' },
  { value: 'ec', text: 'Ecuador', code: '593' },
  { value: 'eg', text: 'Egypt', code: '20' },
  { value: 'sv', text: 'El Salvador', code: '503' },
  { value: 'gq', text: 'Equatorial Guinea', code: '240' },
  { value: 'er', text: 'Eritrea', code: '291' },
  { value: 'ee', text: 'Estonia', code: '372', eu: true },
  { value: 'et', text: 'Ethiopia', code: '251' },
  { value: 'fk', text: 'Falkland Islands (Malvinas)', code: '500' },
  { value: 'fo', text: 'Faroe Islands', code: '298' },
  { value: 'fj', text: 'Fiji', code: '679' },
  { value: 'fi', text: 'Finland', code: '358', eu: true },
  { value: 'fr', text: 'France', code: '33', eu: true },
  { value: 'gf', text: 'French Guiana', code: 0 },
  { value: 'pf', text: 'French Polynesia', code: '689' },
  { value: 'tf', text: 'French Southern Territories', code: 0 },
  { value: 'ga', text: 'Gabon', code: '241' },
  { value: 'gm', text: 'Gambia', code: '220' },
  { value: 'ge', text: 'Georgia', code: '995' },
  { value: 'de', text: 'Germany', code: '49', eu: true },
  { value: 'gh', text: 'Ghana', code: '233' },
  { value: 'gi', text: 'Gibraltar', code: '350' },
  { value: 'gr', text: 'Greece', code: '30', eu: true },
  { value: 'gl', text: 'Greenland', code: '299' },
  { value: 'gd', text: 'Grenada', code: '1473' },
  { value: 'gp', text: 'Guadeloupe', code: 0 },
  { value: 'gu', text: 'Guam', code: '1' },
  { value: 'gt', text: 'Guatemala', code: '502' },
  { value: 'gg', text: 'Guernsey', code: '44' },
  { value: 'gn', text: 'Guinea', code: '224' },
  { value: 'gw', text: 'Guinea-Bissau', code: '245' },
  { value: 'gy', text: 'Guyana', code: '592' },
  { value: 'ht', text: 'Haiti', code: '509' },
  { value: 'hm', text: 'Heard Island and McDonald Islands', code: 0 },
  { value: 'va', text: 'Holy See (Vatican City State)', code: '379' },
  { value: 'hn', text: 'Honduras', code: '504' },
  { value: 'hk', text: 'Hong Kong', code: '852' },
  { value: 'hu', text: 'Hungary', code: '36', eu: true },
  { value: 'is', text: 'Iceland', code: '354' },
  { value: 'in', text: 'India', code: '91' },
  { value: 'id', text: 'Indonesia', code: '62' },
  { value: 'ir', text: 'Iran, Islamic Republic of', code: '98' },
  { value: 'iq', text: 'Iraq', code: '964' },
  { value: 'ie', text: 'Ireland', code: '353', eu: true },
  { value: 'im', text: 'Isle of Man', code: '44' },
  { value: 'il', text: 'Israel', code: '972' },
  { value: 'it', text: 'Italy', code: '39', eu: true },
  { value: 'jm', text: 'Jamaica', code: '876' },
  { value: 'jp', text: 'Japan', code: '81' },
  { value: 'je', text: 'Jersey', code: '44' },
  { value: 'jo', text: 'Jordan', code: '962' },
  { value: 'kz', text: 'Kazakhstan', code: '7' },
  { value: 'ke', text: 'Kenya', code: '254' },
  { value: 'ki', text: 'Kiribati', code: '686' },
  { value: 'kp', text: "Korea, Democratic People's Republic of", code: '850' },
  { value: 'kr', text: 'Korea, Republic of', code: '82' },
  { value: 'kw', text: 'Kuwait', code: '965' },
  { value: 'kg', text: 'Kyrgyzstan', code: '996' },
  { value: 'la', text: "Lao People's Democratic Republic", code: '856' },
  { value: 'lv', text: 'Latvia', code: '371', eu: true },
  { value: 'lb', text: 'Lebanon', code: '961' },
  { value: 'ls', text: 'Lesotho', code: '266' },
  { value: 'lr', text: 'Liberia', code: '231' },
  { value: 'ly', text: 'Libya', code: '218' },
  { value: 'li', text: 'Liechtenstein', code: '423' },
  { value: 'lt', text: 'Lithuania', code: '370', eu: true },
  { value: 'lu', text: 'Luxembourg', code: '352', eu: true },
  { value: 'mo', text: 'Macao', code: '853' },
  { value: 'mk', text: 'Macedonia, the former Yugoslav Republic of', code: '389' },
  { value: 'mg', text: 'Madagascar', code: '261' },
  { value: 'mw', text: 'Malawi', code: '265' },
  { value: 'my', text: 'Malaysia', code: '60' },
  { value: 'mv', text: 'Maldives', code: '960' },
  { value: 'ml', text: 'Mali', code: '223' },
  { value: 'mt', text: 'Malta', code: '356', eu: true },
  { value: 'mh', text: 'Marshall Islands', code: '692' },
  { value: 'mq', text: 'Martinique', code: 0 },
  { value: 'mr', text: 'Mauritania', code: '222' },
  { value: 'mu', text: 'Mauritius', code: '230' },
  { value: 'yt', text: 'Mayotte', code: '262' },
  { value: 'mx', text: 'Mexico', code: '52' },
  { value: 'fm', text: 'Micronesia, Federated States of', code: '691' },
  { value: 'md', text: 'Moldova, Republic of', code: '373' },
  { value: 'mc', text: 'Monaco', code: '377' },
  { value: 'mn', text: 'Mongolia', code: '976' },
  { value: 'me', text: 'Montenegro', code: '382' },
  { value: 'ms', text: 'Montserrat', code: '1' },
  { value: 'ma', text: 'Morocco', code: '212' },
  { value: 'mz', text: 'Mozambique', code: '258' },
  { value: 'mm', text: 'Myanmar', code: '95' },
  { value: 'na', text: 'Namibia', code: '264' },
  { value: 'nr', text: 'Nauru', code: '674' },
  { value: 'np', text: 'Nepal', code: '977' },
  { value: 'nl', text: 'Netherlands', code: '31', eu: true },
  { value: 'nc', text: 'New Caledonia', code: '687' },
  { value: 'nz', text: 'New Zealand', code: '64' },
  { value: 'ni', text: 'Nicaragua', code: '505' },
  { value: 'ne', text: 'Niger', code: '227' },
  { value: 'ng', text: 'Nigeria', code: '234' },
  { value: 'nu', text: 'Niue', code: '683' },
  { value: 'nf', text: 'Norfolk Island', code: 0 },
  { value: 'mp', text: 'Northern Mariana Islands', code: '1' },
  { value: 'no', text: 'Norway', code: '47' },
  { value: 'om', text: 'Oman', code: '968' },
  { value: 'pk', text: 'Pakistan', code: '92' },
  { value: 'pw', text: 'Palau', code: '680' },
  { value: 'ps', text: 'Palestine, State of', code: '970' },
  { value: 'pa', text: 'Panama', code: '507' },
  { value: 'pg', text: 'Papua New Guinea', code: '675' },
  { value: 'py', text: 'Paraguay', code: '595' },
  { value: 'pe', text: 'Peru', code: '51' },
  { value: 'ph', text: 'Philippines', code: '63' },
  { value: 'pn', text: 'Pitcairn', code: '64' },
  { value: 'pl', text: 'Poland', code: '48', eu: true },
  { value: 'pt', text: 'Portugal', code: '351', eu: true },
  { value: 'pr', text: 'Puerto Rico', code: '1' },
  { value: 'qa', text: 'Qatar', code: '974' },
  { value: 'ro', text: 'Romania', code: '40', eu: true },
  { value: 'ru', text: 'Russia', code: '7' },
  { value: 'rw', text: 'Rwanda', code: '250' },
  { value: 're', text: 'Réunion', code: '262' },
  { value: 'bl', text: 'Saint Barthélemy', code: '590' },
  { value: 'sh', text: 'Saint Helena, Ascension and Tristan da Cunha', code: '290' },
  { value: 'kn', text: 'Saint Kitts and Nevis', code: '1869' },
  { value: 'lc', text: 'Saint Lucia', code: '1758' },
  { value: 'mf', text: 'Saint Martin (French part)', code: '590' },
  { value: 'pm', text: 'Saint Pierre and Miquelon', code: '508' },
  { value: 'vc', text: 'Saint Vincent and the Grenadines', code: '1784' },
  { value: 'ws', text: 'Samoa', code: '685' },
  { value: 'sm', text: 'San Marino', code: '378' },
  { value: 'st', text: 'Sao Tome and Principe', code: '239' },
  { value: 'sa', text: 'Saudi Arabia', code: '966' },
  { value: 'sn', text: 'Senegal', code: '221' },
  { value: 'rs', text: 'Serbia', code: '381' },
  { value: 'sc', text: 'Seychelles', code: '248' },
  { value: 'sl', text: 'Sierra Leone', code: '232' },
  { value: 'sg', text: 'Singapore', code: '65' },
  { value: 'sx', text: 'Sint Maarten (Dutch part)', code: '599' },
  { value: 'sk', text: 'Slovakia', code: '421', eu: true },
  { value: 'si', text: 'Slovenia', code: '386', eu: true },
  { value: 'sb', text: 'Solomon Islands', code: '677' },
  { value: 'so', text: 'Somalia', code: '252' },
  { value: 'za', text: 'South Africa', code: '27' },
  { value: 'gs', text: 'South Georgia and the South Sandwich Islands', code: 0 },
  { value: 'ss', text: 'South Sudan', code: '211' },
  { value: 'es', text: 'Spain', code: '34', eu: true },
  { value: 'lk', text: 'Sri Lanka', code: '94' },
  { value: 'sd', text: 'Sudan', code: '249' },
  { value: 'sr', text: 'Suriname', code: '597' },
  { value: 'sj', text: 'Svalbard and Jan Mayen', code: '47' },
  { value: 'sz', text: 'Swaziland', code: 0 },
  { value: 'se', text: 'Sweden', code: '46', eu: true },
  { value: 'ch', text: 'Switzerland', code: '41' },
  { value: 'sy', text: 'Syrian Arab Republic', code: '963' },
  { value: 'tw', text: 'Taiwan, Province of China', code: '886' },
  { value: 'tj', text: 'Tajikistan', code: '992' },
  { value: 'tz', text: 'Tanzania, United Republic of', code: '255' },
  { value: 'th', text: 'Thailand', code: '66' },
  { value: 'tl', text: 'Timor-Leste', code: '670' },
  { value: 'tg', text: 'Togo', code: '228' },
  { value: 'tk', text: 'Tokelau', code: '690' },
  { value: 'to', text: 'Tonga', code: '676' },
  { value: 'tt', text: 'Trinidad and Tobago', code: '868' },
  { value: 'tn', text: 'Tunisia', code: '216' },
  { value: 'tr', text: 'Turkey', code: '90' },
  { value: 'tm', text: 'Turkmenistan', code: '993' },
  { value: 'tc', text: 'Turks and Caicos Islands', code: '1' },
  { value: 'tv', text: 'Tuvalu', code: '688' },
  { value: 'ug', text: 'Uganda', code: '256' },
  { value: 'ua', text: 'Ukraine', code: '380' },
  { value: 'ae', text: 'United Arab Emirates', code: '971' },
  { value: 'gb', text: 'United Kingdom', code: '44' },
  { value: 'us', text: 'United States', code: '1' },
  { value: 'um', text: 'United States Minor Outlying Islands', code: 0 },
  { value: 'uy', text: 'Uruguay', code: '598' },
  { value: 'uz', text: 'Uzbekistan', code: '998' },
  { value: 'vu', text: 'Vanuatu', code: '678' },
  { value: 've', text: 'Venezuela, Bolivarian Republic of', code: '58' },
  { value: 'vn', text: 'Viet Nam', code: '84' },
  { value: 'vg', text: 'Virgin Islands, British', code: '1284' },
  { value: 'vi', text: 'Virgin Islands, U.S.', code: '1' },
  { value: 'wf', text: 'Wallis and Futuna', code: '681' },
  { value: 'eh', text: 'Western Sahara', code: '212' },
  { value: 'ye', text: 'Yemen', code: '967' },
  { value: 'zm', text: 'Zambia', code: '260' },
  { value: 'zw', text: 'Zimbabwe', code: '263' },
  { value: 'ax', text: 'Åland Islands', code: 0 },
];

export function isCountryInEu(country: string): boolean {
  return !!(country && countries.find(({ value }) => value === country)?.eu);
}
